import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

import { departmentsQueryOptions } from '~/lib/departments';

const STORAGE_KEY = 'kiku:last-dept-slug';

export const Route = createFileRoute('/_authenticated/org/$orgSlug/department/$deptSlug')({
  beforeLoad: ({ context, params }) => {
    const data = context.queryClient.getQueryData(departmentsQueryOptions.queryKey);
    if (!data) return;

    const departments = data.departments;
    const isValid = departments.some((d) => d.slug === params.deptSlug);

    if (isValid) {
      localStorage.setItem(STORAGE_KEY, params.deptSlug);
      return;
    }

    // Dept not accessible — resolve fallback
    const stored = localStorage.getItem(STORAGE_KEY);
    const fallback = (stored ? departments.find((d) => d.slug === stored) : null) ?? departments[0];

    if (fallback) {
      localStorage.setItem(STORAGE_KEY, fallback.slug);
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({
        to: '/org/$orgSlug/department/$deptSlug/jobs',
        params: { orgSlug: params.orgSlug, deptSlug: fallback.slug }
      });
    }
  },
  component: () => <Outlet />
});
